<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<Button class="mr" type="primary" icon="ios-add-circle-outline" @click="addSchoolJobShow">新增推荐</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button type="warning" size="small" style="margin-right: 5px"
						@click="reomve(row.id)">删除</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addJobShow" :title="addForm.id?'编辑':'新增'" width="800">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="位置编码" prop="areaCode">
					<Input v-model="addForm.areaCode" maxlength="100" placeholder="请输入岗位名称" clearable></Input>
				</FormItem>
				<FormItem label="icon标题" prop="iconTitle">
					<Input v-model="addForm.iconTitle" maxlength="100" placeholder="请输入岗位名称" clearable></Input>
				</FormItem>
				<FormItem label="icon图片" prop="icon">
					<Upload :action="uploadFile" name="file" :on-success="codeImgBack" :default-file-list="codeImgs"
						:data="uploadData" accept="image/*">
						<Button icon="ios-cloud-upload-outline">icon图片</Button>
					</Upload>
				</FormItem>
				<FormItem label="跳转类型" prop="linkType">
					<RadioGroup v-model="addForm.linkType">
						<Radio label="1">h5链接</Radio>
						<Radio label="2">第三方小程序</Radio>
						<Radio label="3">内部小程序</Radio>
						<Radio label="4">内部岗位合集</Radio>
						<Radio label="5">图片</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem v-if="addForm.linkType=='1'" label="h5链接" prop="content">
					<Input v-model="addForm.content" placeholder="请输入h5链接" clearable></Input>
				</FormItem>
				<template v-if="addForm.linkType=='2'">
					<FormItem label="小程序原始id" prop="mpOriginAppId">
						<Input v-model="addForm.mpOriginAppId" placeholder="请输入小程序原始id" clearable></Input>
					</FormItem>
					<FormItem label="小程序appId" prop="mpAppId">
						<Input v-model="addForm.mpAppId" placeholder="请输入小程序appId" clearable></Input>
					</FormItem>
					<FormItem label="小程序path" prop="content">
						<Input v-model="addForm.content" placeholder="请输入小程序path" clearable></Input>
					</FormItem>
				</template>
				<FormItem v-if="addForm.linkType=='3'" label="内部小程序" prop="content">
					<Input v-model="addForm.content" placeholder="请输入内部小程序链接" clearable></Input>
				</FormItem>
				<FormItem v-if="addForm.linkType=='4'" label="内部岗位合集" prop="content">
					<Input v-model="addForm.content" placeholder="请输入内部岗位合集" clearable></Input>
				</FormItem>
				<FormItem v-if="addForm.linkType=='5'" label="图片" prop="content">
					<Upload :action="uploadFile" name="file" :on-success="imgBack" :default-file-list="imgs"
						:data="uploadData" accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传图片</Button>
					</Upload>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrEditData">确认提交</Button>
			</div>
		</Modal>


	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition8'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				uploadFile: api.statistics.uploadFile,
				uploadData: {
					filePath: 'img'
				},
				queryParams: {

				},
				codeImgs: [],
				imgs:[],
				addJobShow: false,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addForm: {
					id: undefined,
					areaCode: undefined,
					iconTitle: undefined,
					icon: undefined,
					linkType: undefined,
					content: undefined,
					mpOriginAppId:undefined,
					mpAppId:undefined,
				},
				addRule: {
					areaCode: [{
						required: true,
						message: '请填写位置编码',
						trigger: 'blur',
					}],
					iconTitle: [{
						required: true,
						message: '请填写icon标题',
						trigger: 'blur',
					}],
					icon: [{
						required: true,
						message: '请上传icon图标',
						trigger: 'blur',
					}],
					linkType: [{
						required: true,
						message: '请选择跳转类型',
						trigger: 'blur',
					}],
					content: [{
						required: true,
						message: '请填写内容',
						trigger: 'blur',
					}],					
				},
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '位置编码',
						width: 200,
						key: 'areaCode',
						align: 'center'
					},
					{
						title: 'icon标题',
						width: 200,
						key: 'iconTitle',
						align: 'center'
					},
					{
						title: 'icon',
						width: 300,
						key: 'icon',
						align: 'center'
					},			
					{
						title: '跳转类型',
						align: 'center',
						width: 200,
						render: (h, params) => {
							let name;
							let val = params.row.linkType;
							if (val == '1') {
								name = 'h5链接'
							} else if (val == '2') {
								name = '第三方小程序'
							}else if (val == '3') {
								name = '内部小程序'
							}else if (val == '4') {
								name = '内部岗位合集'
							}else if (val == '5') {
								name = '图片'
							}
							return h('span', name)
						}
					},{
						title: '类型内容',
						width: 300,
						key: 'content',
						align: 'center'
					},{
						title: '小程序appId',
						width: 200,
						key: 'mpAppId',
						align: 'center'
					},{
						title: '小程序原始id',
						width: 200,
						key: 'mpOriginAppId',
						align: 'center'
					}, {
						title: '创建日期',
						key: 'updateTime',
						align: 'center',
						width: 300,
					}, {
						title: '操作',
						slot: 'action',
						width: 350,
						align: 'center'
					}

				]
			},

		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.jobRecommandPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},

			logoImgBack(response, file, fileList) {
				this.addForm.imgUrl = response.data.url
			},
			addSchoolJobShow() {
				this.addForm = {
					id: undefined,
					areaCode: undefined,
					icon: undefined,
					linkType: undefined,
					content: undefined
				}
				this.addJobShow = true
			},
			addOrEditData(row) {
				const that = this
				let addData = this.addForm
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						api.statistics
							.addOrEditJobRecommand(addData)
							.then(res => {
								that.addJobShow = false
								that.refreshData()
							})
					}
				})
			},
	
			reomve(id) {
				const that = this
				api.statistics
					.jobRecommandRemove({
						ids:[id]
					})
					.then(res => {
						that.$Message.success('Success!');
						that.getData()
					})
			},
			editData(data) {
				this.addForm = data
				this.addJobShow = true
			},
			codeImgBack(response, file, fileList) {
				this.addForm.icon = response.data.url
				this.codeImgs = [{
					name: response.data.url,
					url: response.data.url
				}]
			},
			imgBack(response, file, fileList) {
				this.addForm.content = response.data.url
				this.imgs = [{
					name: response.data.url,
					url: response.data.url
				}]
			},
		},

	}
</script>
<style>
	.detail {
		display: flex;
		flex-direction: row;
	}
</style>